// позже можно вернуть
//import {COMMIT} from "./generated";

export const ENVIRONMENT_GLOBAL = {
  useInMemoryBackend: true,
  protocol: "http",
  host: "127.0.0.1",
  port: "4200",
  backendApiRoot: "dx-fake-api",
  useAuth: false,
  baseUrl: "",
  loggerLevel: "DEBUG",
  logObjectMapping: false,
  // Количество периодов планирования
  planPeriods: 3,
  // настройки соединения с сервером аутентификации keycloak
  keycloak: {
    serverUrl: 'http://10.10.0.6:8180',
    realm: 'plan_it',
    clientId: 'plan_it_client'
  },
  commit: null
};
